module.exports = __webpack_public_path__ + "img/product-placeholder-33.1dc868e.png";